<template>

<el-container class="api-market">
  <el-header class="header">
    <div class="bg">
      <img class="one" src="../imgs/img_element_one.svg" alt=""/>
      <img class="two" src="../imgs/img_element_two.svg" alt=""/>
      <DocumentHeader title="海量API接口在这里"/>
      <FullSearch style="margin-top: 50px"
                  v-model="keyword"
                  docType="2"
                  @search="getSearchList"/>
    </div>
  </el-header>
  <el-main class="content">
    <el-tabs class="tabs" v-model="currentCateid">
      <el-tab-pane label="全部" name="all">
        <div v-for="(apiCate, index) in cateList" :key="index">
          <div class="api-cate" v-if="apiCate.open_api && apiCate.open_api.length">
            <div class="cate-title">{{apiCate.name}}</div>
            <div class="api-list">
              <div class="api" v-for="(api, apiIndex) in apiCate.open_api" :key="apiIndex"
                   @click="gotoApiDocument(api.cate_id, api.id)">
                <span class="hot" v-if="api.is_hot == '1'"><i class="el-icon-s-opportunity" style="color: red"></i></span>
                <div class="api-title">
                  <span class="title-text">{{api.title}}</span>
                  <span class="free" v-if="api.fee_way == '2'">免费</span>
                </div>
                <div class="api-info">{{api.desc}}</div>
              </div>
            </div>
          </div>

        </div>
      </el-tab-pane>
      <el-tab-pane v-for="(apiCate, index) in  cateList"
                   :label="apiCate.name"
                   :name="apiCate.id"
                   :key="index">
        <div class="api-list" v-if="apiCate.open_api && apiCate.open_api.length">
          <div class="api"
               v-for="(api, apiIndex) in apiCate.open_api"
               :key="apiIndex"
               @click="gotoApiDocument(api.cate_id, api.id)">
            <span class="hot" v-if="api.is_hot == '1'"><i class="el-icon-s-opportunity" style="color: red"></i></span>
            <div class="api-title">
              <span class="title-text">{{api.title}}</span>
              <span class="free" v-if="api.fee_way == '2'">免费</span>
            </div>
            <div class="api-info">{{api.desc}}</div>
          </div>
        </div>
        <el-empty v-else description="暂无API数据"/>
      </el-tab-pane>
    </el-tabs>
  </el-main>
</el-container>
</template>

<script>
  import DocumentHeader from '../DocumentHeader'
  import FullSearch from '../FullSearch'
  import apis from '@/api/apis'
  export default {
    name: "document",
    components:{ DocumentHeader, FullSearch },
    data(){
      return {
        keyword: '',
        cateList: [],
        currentCateid: 'all'
      }
    },
    mounted() {
      this.getApi()
    },
    methods: {
      getSearchList(){
        this.$router.push({
          name:'search',
          params: {keyword:this.keyword,docType:'2'} //1=文档，2=API，3=公告
        })
      },
      getApi(){
        apis.apiMarket.api().then(res => {
          this.cateList = res.data
        })
      },
      gotoApiDocument(cateId, id){
        this.$router.push(`/apiDocument/${cateId}/document/${id}`)
      }
    }
  }
</script>
<style scoped lang="scss">

  .api-market{
    min-height: 100%;
    background: #FAFAFA;
    p{
      text-align: center;
      font-size: 30px;
    }
    .header {
      height: 300px !important;
      background: linear-gradient(180deg, #FFFFFF 0%, #F2F5FA 100%);
      padding: 47px 0 0;
      position: relative;
      .bg {
        width: 1280px;
        height: 100%;
        margin: 0 auto;
        position: relative;
        img.one {
          width: 120px;
          position: absolute;
          z-index: 9;
          left: 60px;
          bottom: 50px;
        }
        img.two {
          width: 150px;
          position: absolute;
          z-index: 9;
          right: 66px;
          top: 0px;
        }
      }

    }
    .content{
      .tabs {
        .api-cate{
          .cate-title{
            font-size: 32px;
            font-weight: 500;
            color: #1E1E28;
            line-height: 45px;
            margin: 20px 0;
          }
        }
        .api-list{
          display: flex;
          flex-wrap: wrap;
          margin-left: -15px;
          .api{
            width: 410px;
            height: 160px;
            background: #FFFFFF;
            border: 1px solid #EBEBEB;
            padding: 30px;
            margin: 0 0px 20px 20px;
            position: relative;
            cursor: pointer;
            &:hover{
              box-shadow: 0px 20px 40px -20px rgba(0, 0, 0, 0.1);
            }
            .hot{
              font-size: 25px;
              position: absolute;
              right: 20px;
              top: 20px;
            }
            .api-title{
              font-size: 18px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.85);
              line-height: 36px;
              display: flex;
              align-items: center;

              .title-text{
                display: inline-block;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
              &:before{
                content: '';
                display: inline-block;
                width: 12px;
                height: 16px;
                background: url("../imgs/icon_more_btn.svg");
                background-size: cover;
                margin-right: 10px;
                flex: none;
              }
              .free{
                display: inline-block;
                height: 17px;
                padding: 1px 3px;
                line-height: 14px;
                border-radius: 2px;
                border: 1px solid #FC2326;
                color: #FC2326;
                margin-left: 8px;
                font-size: 12px;
                flex: none;
              }
            }
            .api-desc{
              font-size: 14px;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.45);
              line-height: 26px;
              margin-top: 10px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: box;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }
        }
      }
      ::v-deep.tabs {
        background: #fff;
        .el-tabs__nav-wrap::after {
          display: none;
        }
        .el-tabs__item.is-active {
          color: #1E1E28;
          font-weight: 500;
          font-size: 14px;
          border-bottom: 4px solid #000 ;
        }
        .el-tabs__active-bar {
          display: none;
        }
        .el-tabs__item{
          text-align: center;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          color: rgba(0, 0, 0, 0.45);
          padding: 0;
          margin: 0 30px;
        }
        .el-tabs__item:hover {
          color: #1E1E28;
        }
        .el-tabs__header{
          width: 1280px;
          margin: auto;
          .el-tabs__nav-wrap{
            padding: 20px 20px 0;
          }
          .el-tabs__nav-next, .el-tabs__nav-prev {
            top: 0;
            line-height: 60px;
            i{
              font-weight: bold;
              font-size: 16px;
              color: #1E1E28;
              &:hover{
                color: #000;
                transform: scale(1.1);
              }
            }

          }
        }
        .el-tabs__content{
          background: #FAFAFA;
          .el-tab-pane{
            padding-top: 20px;
            width: 1280px;
            margin: auto;
          }
        }

      }
    }
  }

</style>
